export type CreateProjectPlanTicketRequest = {
  pjtId: string;
  updateDateTimeTPjt: string;
};
